import { Link } from 'react-router-dom';
const EventsArray2025 = [ 
     {
        venue: 'Department of Mathematics and Statistics,IIT Tirupati',
        link: "https://files.iittp.ac.in/2026/latest_news/Actuarial_Data_Science.pdf",
        title: `National Workshop on Actuarial Data Science`,
        description: <>The Department of Mathematics and Statistics, IIT Tirupati, is organizing a National Workshop on Actuarial Data Science from 14th to 19th December 2026.
        <Link to="https://files.iittp.ac.in/2026/latest_news/Actuarial_Data_Science.pdf" target='_blank;'><b>Workshop Flyer</b> - Click here</Link><Link to="https://elearn.nptel.ac.in/product-page/national-workshop-on-actuarial-data-science" target='_blank;'><b>To Register</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/2026/latest_news/Actuarial_Data_Science.png',
        dt: "14-19",
        my: "December 2026",
        glow: "No",
        duration: '9:00 AM to 5:00 PM',
    },  
    {
        venue: 'Dept. of Humanities and Social Sciences, IIT Tirupati',
        link: "https://files.iittp.ac.in/2026/latest_news/Event_Natural_Capital_HSS.pdf",
        title: `Natural Capital, Nature-Based Solutions to Climate Change, and Valuation of Ecosystem Services: A Commons Perspective`,
        description: <>Organizing the Winter School on "Natural Capital, Nature-Based Solutions to Climate Change, and Valuation of Ecosystem Services: A Commons Perspective" in collaboration with ISEE, FES, UNU-CRIS, PEDRR, Asia Science Mission, and IUCN.
        <Link to="https://files.iittp.ac.in/2026/latest_news/Event_Natural_Capital_HSS.pdf" target='_blank;'><b>Workshop Flyer</b> - Click here</Link><Link to="https://docs.google.com/forms/d/e/1FAIpQLSdYUFCSqeaHX-I_3PamMv0Zcp-Q1IOu4C2Qu0Vp46tr5Baq9A/viewform" target='_blank;'><b>To Register</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/2026/latest_news/Event_Natural_Capital_HSS.png',
        dt: "9-14",
        my: "December 2026",
        glow: "No",
        duration: '09:00 PM - 05:00 PM',
    }, 
    {
        venue: 'Dept. of Physics, IIT Tirupati',
        link: "https://sites.google.com/view/csml-iittp-2026/",
        title: `Workshop on Complex Systems & Machine Learning`,
        description: <>The workshop on Complex Systems & Machine Learning aims to bring together researchers and students working in statistical physics, non-equilibrium dynamics, complex many-body systems, and machine learning. </>,
        img: 'https://files.iittp.ac.in/2026/latest_news/CSML2026.png',
        dt: "2-4",
        my: "October 2026",
        glow: "No",
        duration: '09:00 PM - 05:00 PM',
    }, 
    {
        venue: 'CoE building first floor ,STL lab, IIT Tirupati',
        link: "https://files.iittp.ac.in/2026/latest_news/NVH_brochure.pdf",
        title: `Understanding Industrial NVH ( Noise, Vibration, Harshness) :Theory & Measurement`,
        description: <>The programme provides theoretical understanding and practical exposure to NVH measurements, modal analysis, vibration measurement, data acquisition, signal processing, steady-state and transient analysis, and dynamic testing using advanced sensors, hardware,+- and software.</>,
        img: 'https://files.iittp.ac.in/2026/latest_news/NVH3day_poster.png',
        dt: "1-3",
        my: "October 2026",
        glow: "No",
        duration: '09:00 PM - 05:00 PM',
    }, 
    {
        venue: 'CoE building first floor ,IIOT lab, IIT Tirupati',
        link: "https://files.iittp.ac.in/2026/latest_news/coe_iot_brochure.pdf",
        title: `Industrial Internet of Things Data Integration & Cloud Analytics for Smart Industry`,
        description: <> IIT Tirupati is organising a 3-Day training programme on “Industrial Internet of Things: Data Integration & Cloud Analytics for Smart Industry” from 24–26 September 2026. The programme provides practical exposure to IIoT systems, including real-time sensor data acquisition, edge and cloud computing, data visualization, and cloud-based analytics for smart industry applications.</>,
        img: 'https://files.iittp.ac.in/2026/latest_news/coe_iot_image.png',
        dt: "24-26",
        my: "September 2026",
        glow: "No",
        duration: '09:00 PM - 05:00 PM',
    }, 
    {
        venue: 'Centre of Excellence in Maritime and Ship building (CEMS) Visakhapatnam',
        link: "https://files.iittp.ac.in/2026/latest_news/coe_dsc_brochure.pdf",
        title: `Distributed Control systems for engineers`,
        description: <>A 4-Day Intensive Training Programme on “Distributed Control Systems (DCS) for Engineers” from 15–18 September 2026 at CEMS, Visakhapatnam. The programme provides practical exposure to DCS concepts, industrial automation, control systems, real-world applications, and hands-on learning for industry professionals, engineers, faculty, and researchers.</>,
        img: 'https://files.iittp.ac.in/2026/latest_news/coe_dsc_image.png',
        dt: "15-18",
        my: "September 2026",
        glow: "No",
        duration: '09:00 PM - 05:00 PM',
    }, 
    {
        venue: 'Centre of Excellence in Maritime and Ship building (CEMS) Visakhapatnam',
        link: "https://files.iittp.ac.in/2026/latest_news/coe_starccm_brochure.pdf",
        title: `Learning Computational Fluid Dynamics using Star CCM+`,
        description: <>A 3-Day Executive Training Programme on “Learning Computational Fluid Dynamics with STAR-CCM+” from 1st–3rd September 2026. The programme offers industry-oriented hands-on training in CFD simulation, meshing, physics setup, post-processing, and practical industrial case studies using STAR-CCM+</>,
        img: 'https://files.iittp.ac.in/2026/latest_news/coe_starccm_image.png',
        dt: "01-03",
        my: "September 2026",
        glow: "No",
        duration: '09:00 PM - 05:00 PM',
    },
    {
        venue: 'LHC-CR211 - IIT Tirupati',
        link: "https://files.iittp.ac.in/2026/latest_news/India_From_Orbit.pdf",
        title: `Distinguished Lecture by Group Captain Shubhanshu Shukla , Ashok Chakra, Astronaut`,
        description: <>Title of the talk: India From Orbit - Space through an Astronaut’s eyes <b>Astronaut and test pilot, speaking on what orbit reveals about our planet — and about the work of getting there.</b></>,
        img: 'https://files.iittp.ac.in/2026/latest_news/India_From_Orbit_page_001.png',
        dt: "21",
        my: "August",
        glow: "No",
        duration: '04:00 PM',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/webinar_AEST_26_updated.pdf",
        title: `Webinar: M.Tech. in Advanced Energy Storage Technology (AEST)`,
        description: <>The Indian Institute of Technology Tirupati invites you to an exclusive webinar to learn more about the <b>eCampus M.Tech. Programme in Advanced Energy Storage Technology (AEST)</b> on 20th May 2026.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/webinar_AEST_26_updated.pdf" target='_blank;'><b>Brochure</b> - Click here</Link><Link to="https://forms.gle/QzBTeQE68k93cgZ97" target='_blank;'><b>Registration Link</b> - Click here</Link><Link to="https://zoom.us/j/95409925747?pwd=Mj4Z5KF4S9bzEn70saa1RjfC72nNVh.1" target='_blank;'><b>Zoom Meeting Link</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/webinar_AEST_26_updated.png',
        dt: "20",
        my: "May",
        glow: "No",
        duration: '05:00 PM - 07:00 PM',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/BMC_workshop.jpg",
        title: `"Business Model Canvas"`,
        description: <>The Institute’s Innovation Council of IIT Tirupati, in collaboration with RTIH Tirupati, is organizing a half-day workshop on the Business Model Canvas (BMC). This workshop is a great opportunity to get hands-on experience and expert guidance in developing your own BMC.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/BMC_workshop.jpg" target='_blank;'><b>Poster</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/BMC_workshop.jpg',
        dt: "22",
        my: "April",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/PCA_May_2026_Brochure.pdf",
        title: `"Programmable Controllers and Applications"`,
        description: <>The Centre of Excellence – Smart Manufacturing & EV Technology (CoE SMEVT) is organizing a 3-Day Offline Training Program titled “Programmable Controllers and Applications” from 30 April to 2 May 2026 at IIT Tirupati.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/PCA_May_2026_Brochure.pdf" target='_blank;'><b>Flyer</b> - Click here</Link><Link to="https://forms.gle/evp1qM8EcTgcSWxg7" target='_blank;'><b>Registration Link</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/PCA_May_2026_Brochure_1.jpg',
        dt: "30-2",
        my: "April",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/Additive_Manufacturing_May_2026.pdf",
        title: `Additive Manufacturing: From Design to Production`,
        description: <>The Centre of Excellence in Smart Manufacturing & EV Technologies (CoE-SMEVT), IIT Tirupati, is pleased to announce a 3-day Training Program on <b>Additive Manufacturing: From Design to Production</b>.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/Additive_Manufacturing_May_2026.pdf" target='_blank;'><b>Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/Additive_Manufacturing_May_2026.jpg',
        dt: "04-06",
        my: "May",
        glow: "No",
        duration: '',
    },
     
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/ncrac_brochure_2026.pdf",
        title: `"9th National & 3rd International Conference on "Refrigeration & Air Conditioning""`,
        description: <>The Department of Mechanical Engineering at IIT Tirupati invites you to a four-day conference on "Refrigeration & Air Conditioning",   from 13th - 16th  December 2026 at IIT Tirupati.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/ncrac_brochure_2026.pdf" target='_blank;'><b>Flyer</b> - Click here</Link><Link to="https://ncrac.iittp.ac.in/" target='_blank;'><b>Website Link</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/ncrac_2026.png',
        dt: "13-16",
        my: "Dec",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati (Hybrid Session)',
        link: "https://forms.office.com/pages/responsepage.aspx?id=H6xrR7I22UqGmc2mutH4YvOK86_LXmVGlKZxEWntltpURUxKSlhCTEpZTk9KTFlXR0syUjBHNFlYNy4u&route=shorturl",
        title: `Emerging AI Technologies for a Sustainable Future: Prospects and Challenges`,
        description: <>The workshop will explore emerging approaches for estimating future electricity demand from data centers in India and for integrating them into existing energy modelling frameworks. 
            <Link to="https://forms.office.com/pages/responsepage.aspx?id=H6xrR7I22UqGmc2mutH4YvOK86_LXmVGlKZxEWntltpURUxKSlhCTEpZTk9KTFlXR0syUjBHNFlYNy4u&route=shorturl" target='_blank;'><b>Registration Link</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2026/EmergingAI-Tech.jpg',
        dt: "11",
        my: "April 2026",
        glow: "No",
        duration: '09:00 AM - 05:30 PM',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/Workshop_GSI2026.pdf",
        title: `"Geosynthetics for Sustainable Infrastructure"`,
        description: <>The Department of  Civil & Environmental Engineering, IIT Tirupati, invites you to a two-day workshop on "Geosynthetics for Sustainable Infrastructure" is designed to highlight the critical role of geosynthetic materials in delivering resilient, cost-effective, and environmentally responsible ground engineering solutions, from 13th - 14th March 2026.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/Workshop_GSI2026.pdf" target='_blank;'><b>Flyer</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/Workshop_Brochure_GSI26.png',
        dt: "13-14",
        my: "March ",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/nsd_2026.pdf",
        title: `"Illuminating Pathways of Foundational Science for Laser Matter Interaction Insights"`,
        description: <>The Department of Physics, IIT Tirupati, is pleased to invite you to a Popular Science Lecture as part of the National Science Day 2026 celebration. This year’s celebration is aligned with the theme “Women in Science – Catalyzing Viksit Bharat” and Title of the Lecture: "Illuminating Pathways of Foundational Science for Laser Matter Interaction Insights"<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/nsd_2026.pdf" target='_blank;'><b>Flyer</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/nsd_2026.png',
        dt: "12",
        my: "March ",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/Research_Colloquium_2026.pdf",
        title: `"Research Colloquium"`,
        description: <>The Department of Humanities and Social Sciences (HSS), IIT Tirupati, proudly presents the inaugural "Research Colloquium" on 09 March 2026.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/Research_Colloquium_2026.pdf" target='_blank;'><b>Flyer</b> - Click here</Link><Link to="https://docs.google.com/forms/d/e/1FAIpQLScA-k4yeY-iqKbgQMEckoWrkhS3aVToq-WXwIxBCFRqdlGf2w/viewform" target='_blank;'><b>Registration Link</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/Research_Colloquium_2026.png',
        dt: "09",
        my: "March ",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/MTCS-2026_Flyer.pdf",
        title: `"Modern Trends in Chemical Sciences (MTCS) - 2026"`,
        description: <>The Department of Chemistry at IIT Tirupati invites you to a two-day conference on "Modern Trends in Chemical Sciences (MTCS) - 2026", provides an open platform for budding researchers in applied chemical and materials sciences to engage in meaningful interactions with pioneers in the field from 5th - 6th  March 2026 at IIT Tirupati.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/MTCS-2026_Flyer.pdf" target='_blank;'><b>Flyer</b> - Click here</Link><Link to="https://sites.google.com/iittp.ac.in/mtcs-2026" target='_blank;'><b>Website Link</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/MTCS-2026_Flyer.png',
        dt: "5-6",
        my: "March ",
        glow: "No",
        duration: '',
    },
    
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/IGPT_Infra_BHARAT.pdf",
        title: `Two-day hybrid workshop on "IGPT Infra: BHARAT"`,
        description: <>Indian Institute of Technology Tirupati invites you to a two-day hybrid workshop on IGPT Infra: BHARAT, with the theme "Integrating Green Pavements and Transportation Infrastructure: Bridging Holistic and Applied Research for Advancing Technologies", from 13th to 14th February 2026.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/IGPT_Infra_BHARAT.pdf" target='_blank;'><b>Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/IGPT_Infra_Bharat.png',
        dt: "13-14",
        my: "February ",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2026/laas_workshop_2026.pdf",
        title: `First ILASS-INDIA Meeting & Workshop on "Liquid Atomization and Sprays"`,
        description: <>We are glad to invite you to the "First ILASS-INDIA Meeting & Workshop on Liquid Atomization and Sprays" scheduled to be held at IIT Tirupati, from 29th to 30th January 2026.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2026/laas_workshop_2026.pdf" target='_blank;'><b>Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2026/laas_workshop_2026.png',
        dt: "29-30",
        my: "January",
        glow: "No",
        duration: '',
    },
   
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/NVH_and_Modal_Analysis_Brochure.pdf",
        title: `Understanding Industrial Noise, Vibration & Harshness: Theory and Measurement`,
        description: <>The Centre of Excellence in Smart Manufacturing & EV Technologies (CoE-SMEVT), IIT Tirupati, is pleased to announce a 5-day Training Program on <b>Understanding Industrial Noise, Vibration & Harshness: Theory and Measurement</b>.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/NVH_and_Modal_Analysis_Brochure.pdf" target='_blank;'><b>Brochure</b> - Click here</Link><Link to="https://forms.gle/6odgiGsSECCFb8pP6" target='_blank;'><b>Registration link</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/NVH_and_Modal_Analysis_Brochure.jpg',
        dt: "24-28",
        my: "December",
        glow: "No",
        duration: '',
    },
   
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Plasma_2025_Flyer.pdf",
        title: `40ᵗʰ National Symposium on Plasma Science and Technology (PLASMA 2025)`,
        description: <> IIT Tirupati (Departments of Physics and Civil & Environmental Engineering) and IISER Tirupati cordially invite you to participate in the 40ᵗʰ PSSI National Symposium on “Plasma Science and Technology for a Sustainable Future”, to be held at IIT Tirupati from 27–29 December 2025.<Link to="https://event.ipr.res.in/event/16/" target='_blank;'><b>Abstract Submission</b> - Click here</Link> <Link to="https://files.iittp.ac.in/pdfs/events/2025/Plasma_2025_Flyer.pdf" target='_blank;'><b>Brochure</b> - Click here</Link><Link to="https://www.plasma2025.com/" target='_blank;'><b>Website Link</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/Plasma_2025.png',
        dt: "27-29",
        my: "December",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/IMAP2025_Poster.pdf",
        title: `Initiation into Mathematics`,
        description: <> Department of Mathematics and Statistics, IIT Tirupati, and MTTS invite second-year undergraduate students from Andhra Pradesh, Telangana, and Karnataka to participate in the initMath program, from 29th December 2025 - 3rd January 2026. <Link to="https://files.iittp.ac.in/pdfs/events/2025/IMAP2025_Poster.pdf" target='_blank;'><b>Brochure</b> - Click here</Link><Link to="https://mtts.org.in/programme/im2025ap" target='_blank;'><b>Website Link</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/IMAP2025_Poster.png',
        dt: "29th Dec-3rd Jan",
        my: "December",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/images/events/2025/TRL_MRL_IP_Special_Lecture.png",
        title: `From Idea to Impact - TRL, MRL, IP Commercialisation and Technology Transfer`,
        description: <> The Institution’s Innovation Council and the Research Affairs Council of IIT Tirupati are organising a Special Lecture: "From Idea to Impact - TRL, MRL, IP Commercialisation and Technology Transfer" on 8 January 2026 at IIT Tirupati. <Link to="https://files.iittp.ac.in/images/events/2025/TRL_MRL_IP_Special_Lecture.png" target='_blank;'><b>Brochure</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/TRL_MRL_IP_Special_Lecture.png',
        dt: "8th Jan",
        my: "January",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Flyer_IISM_25.jpg",
        title: `Inter IIT Sports Meet 2025 - Co hosted by `,
        description: <>IIT Tirupati is honoured to host the 58th Inter IIT Sports Meet – 2025, one of the most prestigious and longstanding sporting traditions of the Indian Institutes of Technology. This year’s edition will feature intense competitions in Chess, Tennis, and Weightlifting on our campus, bringing together the finest student-athletes from across the country... <Link to="https://files.iittp.ac.in/pdfs/events/2025/Flyer_IISM_25.jpg" target='_blank;'><b>Event Brochure</b> - Click here</Link><Link to="https://iism25.sports.iittp.ac.in/" target='_blank;'><b>Website Link</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/inter_iitt_sports_meet_2.png',
        dt: "14-21",
        my: "December",
        glow: "No",
        duration: '',
    },
    
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Vacuum_workshop_brochure.pdf",
        title: `Vacuum Technology & Process Applications`,
        description: <>The Indian Institute of Technology Tirupati, in collaboration with the GITAM (Deemed to be University) Bengaluru Campus, is pleased to announce a one week short term course on <b>Vacuum Technology & Process Applications</b> from 08-13 December 2025.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/Vacuum_workshop_brochure.pdf" target='_blank;'><b>Workshop Flyer</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/Vaccum_workshop_brochure.jpg',
        dt: "08-13",
        my: "December",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/IIoT_Brochure.pdf",
        title: `Workshop on Industrial IoT (IIoT): Data Integration & Cloud Analytics for Smart Industry`,
        description: <>The Centre of Excellence in Smart Manufacturing & EV Technologies (CoE-SMEVT), IIT Tirupati, is pleased to announce a 3-day workshop on <b>Industrial Internet of Things(IIoT): Data Integration & Cloud Analytics for Smart Industry</b>.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/IIoT_Brochure.pdf" target='_blank;'><b>Workshop Flyer</b> - Click here</Link><Link to="https://forms.gle/rm52rc94xURPzjkbA" target='_blank;'><b>To Register</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/IIoT_Brochure.jpg',
        dt: "4-6",
        my: "December",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/QKCT_Poster.png",
        title: `Quantum Knowledge Cluster Tirupati (QKCT)`,
        description: <>The first edition of the QKCT (Quantum Knowledge Cluster Tirupati) workshop focusing on Quantum Computing, Quantum Communication and Quantum Information processing. The workshop aims to lay the foundation of the QKCT at IIT Tirupati with support from neighboring academic institutions like IISER Tirupati, SV University and SPMV at Tirupati during December 02-03, 2025.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/QKCT_Poster.png" target='_blank;'><b>Workshop Flyer</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/QKCT_Poster.png',
        dt: "2-3",
        my: "December",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/ATSNPDE25_Flyer.pdf",
        title: `Advanced Training School on Numerical Partial Differential Equations`,
        description: <>The Department of Mathematics and Statistics cordially invites you to participate in the training session on "Advanced Training School on Numerical Partial Differential Equations" at IIT Tirupati during 1-11 December 2025.<Link to="https://forms.gle/9E27fRta8ttqiu4h8" target='_blank;'><b>Google Form Registration</b> - Click here</Link> <Link to="https://files.iittp.ac.in/pdfs/events/2025/ATSNPDE25_Flyer.pdf" target='_blank;'><b>Brochure</b> - Click here</Link><Link to="https://mast.iittp.ac.in/ATSNPDE25/" target='_blank;'><b>Website Link</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/ATSNPDE25_Flyer.jpg',
        dt: "1-11",
        my: "December",
        glow: "No",
        duration: '',
    },
    
   
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/L2M_C2_Poster.png",
        title: `AIC - T-Hub Lab2Market Program Launch`,
        description: <>The Institution's Innovation Council (IIC) of IIT Tirupati is delighted to host the Lab2Market Program Launch, an initiative by the Atal Incubation Centre (AIC) at T-Hub, Hyderabad on 6th November 2025.<br /><Link to="https://docs.google.com/forms/d/e/1FAIpQLSc2u1avl8IVVdY6cy2XNt5SpywShExfCn-Vo8HNz0-Rx93fOQ/viewform?usp=dialog" target='_blank;'><b>Registration link</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/L2M_C2_Poster.png" target='_blank;'><b>Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/L2M_C2_Poster.png',
        dt: "06",
        my: "November",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/CRISP_Poster.pdf",
        title: `Workshop on Public Policy in Practice`,
        description: <>The Department of Humanities and Social Sciences (HSS), IIT Tirupati, in collaboration with the Centre for Research in Schemes and Policies (CRISP), is pleased to announce a 3-day hybrid workshop on <b>Public Policy in Practice</b>.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/CRISP_Poster.pdf" target='_blank;'><b>Workshop Flyer</b> - Click here</Link><Link to="https://forms.gle/6t8EpJDbb2vYkSd77" target='_blank;'><b>To Register</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/CRISP_Poster.jpg',
        dt: "30 Oct - 1 Nov",
        my: "November",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/IAC_25_Brochure.pdf",
        title: `Industry Academia Conclave (IAC) 2025`,
        description: <>The Department of Mechanical Engineering cordially invites you to "Industry-Academia Conclave 2025" Bridging Academia and Industry at IIT Tirupati during 20 September 2025.<br /><Link to="https://iittp.ac.in/iac2025/" target='_blank;'><b>Conference Website</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/IAC_25_Brochure.pdf" target='_blank;'><b>Conference Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/IAC_25_Brochure.png',
        dt: "20",
        my: "September",
        glow: "No",
        duration: '',
    },
  
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/STH_Poster.pdf",
        title: `Understanding Industrial NVH: Theory and Measurement`,
        description: <> We are excited to announce the COE SMEV Training Program on: "Understanding Industrial NVH: Theory and Measurement" at IIT Tirupati during 3-7 Sep 2025.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/STH_Poster.pdf" target='_blank;'><b>Program Brochure</b> - Click here</Link><Link to="https://docs.google.com/forms/d/e/1FAIpQLSfVjIg298O2bfyeDLQLLHcCKPon-K3BrWiasNGYD4rPcXy6Yg/viewform" target='_blank;'><b>To Register</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/STH_Poster.png',
        dt: "3-7",
        my: "September",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/ICFP_25_Brochure.pdf",
        title: `4th International Conference on Friction - Based Processes 2025`,
        description: <> 4th International Conference on "FRICTION BASED PROCESSES-2025" at IIT Tirupati during 6-8 Sep 2025.<br /><Link to="https://iapmfp.org/icfp/index.html" target='_blank;'><b>Conference Website</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/ICFP_25_Brochure.pdf" target='_blank;'><b>Conference Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/icfp_25.png',
        dt: "6-8",
        my: "September",
        glow: "No",
        duration: '',
    },  
    
   
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/dif_12_8_25.pdf",
        title: `Driving Innovation Forward: Key Insights from Startup and Incubation Leaders.`,
        description: <> Institution's Innovation Council (IIC) and the Centre for Sponsored Research & Consultancy (CSRC) at IIT Tirupati, cordially invite you to a lecture session titled "Driving Innovation Forward: Key Insights from Startup and Incubation Leaders." <Link to="https://files.iittp.ac.in/pdfs/events/2025/dif_12_8_25.pdf" target='_blank;'><b>Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/dif_12_8_25.jpg',
        dt: "12",
        my: "August",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/aaw_workshop.pdf",
        title: `Advancing Academic Writing: Mastering Scientific Publishing, Research Integrity and Ethics, & Editorial Insights.`,
        description: <> Institution's Innovation Council (IIC) and the Centre for Sponsored Research & Consultancy (CSRC) at IIT Tirupati, we are pleased to invite you to a half-day workshop titled "Advancing Academic Writing: Mastering Scientific Publishing, Research Integrity and Ethics, & Editorial Insights".<Link to="https://files.iittp.ac.in/pdfs/events/2025/aaw_workshop.pdf" target='_blank;'><b>Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/aaw_workshop.png',
        dt: "31",
        my: "July",
        glow: "No",
        duration: '',
    },
     {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Venture_studios_Poster_IIC.pdf",
        title: `Venture studios - A new paradigm for building deeptech startups!`,
        description: <> The Institute Innovation Council (IIC), IIT Tirupati is organizing an  online lecture session exploring the dynamic world of Venture studios, angel investing, and venture capitalist — where innovation meets capital to build the startups of tomorrow on 17th July 2025 at 3-4 PM.<Link to="https://files.iittp.ac.in/pdfs/events/2025/Venture_studios_Poster_IIC.pdf" target='_blank;'><b>Talk Flyer</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/Venture_studios_Poster_IIC.jpg',
        dt: "17",
        my: "July",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/ICCMS_25.pdf",
        title: `3rd International Conference on Construction Materials and Structures on Synergy of Materials and Structures`,
        description: <> The Department of Civil & Environmental Engineering are organizing the 3rd International Conference on "Construction Materials and Structures on Synergy of Materials and Structures" at IIT Tirupati India during 3-5 July 2025.<br /><Link to="https://theconcreteconference.com/" target='_blank;'><b>Conference Website</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/ICCMS_25.pdf" target='_blank;'><b>Conference Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/ICCMS_25.png',
        dt: "3-5",
        my: "July",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/RMMDA_Workshop2025_IITT_Home.png",
        title: `Five-day on-campus Workshop on Research Methodology & Multivariate Data Analysis`,
        description: <> The Department of Humanities and Social Sciences, IIT Tirupati, is excited to bring you the second edition of this highly acclaimed 5-Day workshop on "Research Methodology and Multivariate Data Analysis" from May 19 to 23, 2025.<br /><Link to="https://docs.google.com/forms/d/e/1FAIpQLSesp0ZeV6EHe1I_TsuVncJE8_iWCaY9xqmJISw4YeQ3PYxetA/viewform" target='_blank;'><b>Registration Link</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/RMMDA_Workshop_2025.pdf" target='_blank;'><b>Workshop Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/RMMDA_Workshop2025_IITT_Home.png',
        dt: "19-23",
        my: "May",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Workshop_on_Law_Economics_and_Public_Policy_2025.jpg",
        title: `Two-day International Workshop on Law, Economics and Public Policy`,
        description: <> The Department of Humanities and Social Sciences, in association with Office of Global Engagement, Alumni and Corporate Relations, is organizing a two-day International workshop on "Law, Economics and Public Policy" from May 7 to 8, 2025.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/Workshop_on_Law_Economics_and_Public_Policy_2025.pdf" target='_blank;'><b>Workshop Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/Workshop_on_Law_Economics_and_Public_Policy_2025.jpg',
        dt: "7-8",
        my: "May",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/IPR_day_2025.jpg",
        title: `Navigating the Patent Journey in India and Beyond`,
        description: <> To mark World IPR day, The Institute Innovation Council (IIC) at IIT Tirupati is organizing an engaging online lecture session by Speaker: Mr. Stephen Gunaseelan, IPR Consultant on "From Idea to Innovation: Navigating the Patent Journey in India and Beyond" on 26th April 2025 at 2-3 PM. <br /><Link to="https://zoom.us/j/97424725034?pwd=rxFhGc6OMaDYz4UXBbrOavaAlsp11M.1" target='_blank;'><b>Zoom Link</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/pdfs/events/2025/IPR_day_2025.jpg',
        dt: "26",
        my: "April",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/TI_HW_Hackathon_IIT_Tirupati_2025-1.pdf",
        title: `Analog Hardware Design Contest`,
        description: <> The Electrical Engineering Department is organizing the "Analog Hardware Design Contest 2025"  in collaboration with Texas Instruments on 08 March 2025. </>,
        img: 'https://files.iittp.ac.in/pdfs/events/2025/TI_HW_Hackathon_IIT_Tirupati_2025-1-1.jpg',
        dt: "7-8",
        my: "March",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/AM_Workshop.pdf",
        title: `Indo-German Symposium on Advances in Additive Manufacuring`,
        description: <> The Department of Mechanical Engineering in association with DST (IGSTC) are jointly organizing the two days Indo-German Symposium on "Advances in Additive Manufacuring" at IIT Tirupati India during 3-4 March 2025.<br /><Link to="https://docs.google.com/forms/d/e/1FAIpQLScy9AyzBR6tpiBRzYwzvLDWTWNficWTi8eaHqBvnjYpcImXEg/viewform?usp=pp_url" target='_blank;'><b>Registration Link</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/AM_Workshop.pdf" target='_blank;'><b>Symposium Brochure</b> - Click here</Link> </>,
        img: 'https://files.iittp.ac.in/images/events/2025/AM_Workshop.png',
        dt: "3-4",
        my: "March",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://sites.google.com/iittp.ac.in/idiaworkshop2025/home#h.kz1uxyxeaws4",
        title: `System Design and Architecture (SDA), and System Level Electrical Test (SLET)`,
        description: <>IDSPS Industry Academia Workshop on "System Design and Architecture (SDA), and System Level Electrical Test (SLET)"</>,
        img: 'https://files.iittp.ac.in/images/events/2025/IDSPS_Workshop.png',
        dt: "28",
        my: "February",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Conference_Socio_Economics.pdf",
        title: `Conference on Socio-Economic Determinants and Inequalities in Access to Water`,
        description: <>The Department of Humanities and Social Sciences in collaboration with Indian Council of Social Science Research, is organizing a one-day Conference on "Socio-Economic Determinants and Inequalities in Access to Water"</>,
        img: 'https://files.iittp.ac.in/images/events/2025/Conference_Socio_Economics.png',
        dt: "24",
        my: "February",
        glow: "No",
        duration: '',
    },
   
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Workshop_Flyer_HSS-IITT_Mongabay_India.pdf",
        title: `Connecting the Dots: Communicating Scientific Research through the Media`,
        description: <>The Dept. of Humanities and Social Sciences, in collaboration with MONGABAY India (https://india.mongabay.com/), is organizing a two-day workshop on "Connecting the Dots: Communicating Scientific Research through the Media"</>,
        img: 'https://files.iittp.ac.in/images/events/2025/Workshop_Flyer_HSS-IITT_Mongabay_India.png',
        dt: "7-8",
        my: "February",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/Flyer_IIC_2025_ME_dept_23_12.pdf",
        title: `Industry Institute Conclave (IIC) 2025`,
        description: <>The Department of Mechanical Engineering is organizing a one-day conference entitled "<b>Industry Institute Conclave (IIC) 2025"</b>.<br /><Link to="https://files.iittp.ac.in/pdfs/events/2025/Invitation_Letter_IIC.pdf" target='_blank;'><b>Invitation Letter</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/Flyer_IIC_2025_ME.pdf" target='_blank;'><b>Program Brochure</b> - Click here</Link><Link to="https://files.iittp.ac.in/pdfs/events/2025/Department_Brochure_ME.jpg" target='_blank;'><b>Department Brochure</b> - Click here</Link></>,
        img: 'https://files.iittp.ac.in/images/events/2025/Flyer_IIC_2025_ME_IIT_Tirupati.jpg',
        dt: "1",
        my: "February",
        glow: "No",
        duration: '',
    },
    {
        venue: 'IIT Tirupati',
        link: "https://files.iittp.ac.in/pdfs/events/2025/GIAN_Course_6_1_2025.pdf",
        title: `High Speed Flow Theory and Measurements in Jet Engines`,
        description: <>The Department of Mechanical Engineering is organizing a GIAN course titled "<b>High-Speed Flow Theory and Measurements in Jet Engines,"</b> to be delivered by <b>Prof. Lionel Christopher Ganippa</b> from Brunel University, London, UK. The course will be held from January 6th to 10th, 2025, at IIT Tirupati.</>,
        img: 'https://files.iittp.ac.in/images/events/2025/GIAN_Course_6_1_2025.png',
        dt: "6-10",
        my: "January",
        glow: "No",
        duration: '',
    }
    
   


]

export default EventsArray2025;